import axios from "axios";
import { STATUSES } from "./apiStatus";
import { base_url } from "../utils";
import { getAccesstoken } from "../helpers/utils";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const creditlogs = createAsyncThunk("credit/fetch",async (_, { rejectWithValue, serializeError }) => {
    try {
      const token = getAccesstoken();
      const response = await axios.get(`${base_url}/digilocker/get_credit_logs`,{
         headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      console.log("rtk response data", response)
      return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const creditlogsSlice = createSlice({
  name: "credit",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(creditlogs.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(creditlogs.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(creditlogs.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default creditlogsSlice.reducer;
